import React from 'react';
import { TableRow, TableCell } from '@mui/material';

const CommissionTableRow = ({
  id,
  createdDate,
  date,
  customerID,
  customerName,
  customerType,
  customerLocation,
  agent,
  minCommitment,
  total,
  plan_currency,
}) => (
  <TableRow key={`commission_${id}`}>
    <TableCell>{createdDate}</TableCell>
    <TableCell>{date}</TableCell>
    <TableCell>{customerID}</TableCell>
    <TableCell>{customerName}</TableCell>
    <TableCell>{customerType}</TableCell>
    <TableCell>{customerLocation}</TableCell>
    <TableCell>{agent || 'No agent'}</TableCell>
    <TableCell>{total}</TableCell>
    <TableCell>{plan_currency}</TableCell>
    <TableCell>{minCommitment}</TableCell>
  </TableRow>
);

export default CommissionTableRow;
